import { Injectable } from "@angular/core";
import { BaseMapperWithSerializer } from "../../base.mapper";
import { PostHospitalRequestModel } from "../../../models/apis/system/hospital/post-hospital-request.model";
import { DataResponseHttp } from "../../../http-models/data-response.http";
import { HospitalHttp } from "../../../http-models/systems/hospital/hospital.http";
import { DataResponseModel } from "../../../models/apis/data-response.model";
import { HospitalModel } from "../../../models/apis/system/hospital/hospital.model";


@Injectable({
    providedIn: 'root',
})
export class PostHospitalMapper implements BaseMapperWithSerializer
<PostHospitalRequestModel, FormData, DataResponseModel<HospitalModel>, DataResponseHttp<HospitalHttp>> {

    convertTo(model: PostHospitalRequestModel): FormData {
        const request: FormData = new FormData();
        request.append("name", model.name);
        request.append("code", model.code);
        if (model.address1) {
            request.append("address1", model.address1);
        }
        if (model.address2) {
            request.append("address2", model.address2);
        }
        if (model.contactNumber) {
            request.append("contactNumber", model.contactNumber);
        }
        if (model.halalPrinterName) {
            request.append("halalPrinterName", model.halalPrinterName);
        }
        if (model.nonHalalPrinterName) {
            request.append("nonHalalPrinterName", model.nonHalalPrinterName);
        }
        if (model.pictureCollapsed) {
            request.append("pictureCollapsed", model.pictureCollapsed, model.pictureCollapsedFileName);
        }
        if (model.pictureExpanded) {
            request.append("pictureExpanded", model.pictureExpanded, model.pictureExpandedFileName);
        }
        if (model.useMealUpgradeOption) {
            request.append("useMealUpgradeOption", model.useMealUpgradeOption.toString());
        }
        if (model.mealUpgradeOption) {
            request.append("mealUpgradeOption", model.mealUpgradeOption);
        }
        if (model.autoOrderTea) {
            request.append("autoOrderTea", model.autoOrderTea.toString());
        }
        if (model.autoOrderTeaFollowPrevMeal) {
            request.append("autoOrderTeaFollowPrevMeal", model.autoOrderTeaFollowPrevMeal.toString());
        }
        if (model.autoOrderMealClass) {
            request.append("autoOrderMealClass", model.autoOrderMealClass);
        }
        if (model.autoOrderForPlanned) {
            request.append("autoOrderForPlanned", model.autoOrderForPlanned.toString());
        }
        if (model.autoOrderMail) {
            request.append("autoOrderMail", model.autoOrderMail);
        }
        if (model.navbarBackgroundColor) {
            request.append("navbarBackgroundColor", model.navbarBackgroundColor);
        }
        if (model.navbarForegroundColor) {
            request.append("navbarForegroundColor", model.navbarForegroundColor);
        }
        if (model.pbtBehaviorOption) {
            request.append("PBTBehaviorOption", model.pbtBehaviorOption.toString());
        }
        if (model.pbtShowGuestMealOrderOption) {
            request.append("PBTShowGuestMealOrderOption", model.pbtShowGuestMealOrderOption.toString());
        }
        if (model.showQrCodeinMealSlip != undefined || model.showQrCodeinMealSlip == null) {
            request.append("showQrCodeinMealSlip", model.showQrCodeinMealSlip.toString());
        }
        if (model.enableDns153 != undefined || model.enableDns153 == null) {
            request.append("enableDns153", model.enableDns153.toString());
        }

        return request;
    }

    convertFrom(http: DataResponseHttp<HospitalHttp>): DataResponseModel<HospitalModel> {
        let response = {
            isError: http.isError,
            errors: http.errors
        } as DataResponseModel<HospitalModel>;
        if (http.isError != true && http.data) {
            response.data = {
                id: http.data.id,
                name: http.data.name,
                code: http.data.code,
                address1: http.data.address1 ?? '',
                address2: http.data.address2 ?? '',
                contactNumber: http.data.contactNumber ?? '',
                halalPrinterName: http.data.halalPrinterName ?? '',
                nonHalalPrinterName: http.data.nonHalalPrinterName ?? '',
                pictureCollapsedUrl: http.data.pictureCollapsedUrl ?? '',
                pictureExpandedUrl: http.data.pictureExpandedUrl ?? '',
                isActive: http.data.isActive,
                createdBy: http.data.createdBy,
                createdDateUtc: new Date(http.data.createdDateUtc),
                updatedBy: http.data.updatedBy,
                updatedDateUtc: new Date(http.data.updatedDateUtc),
                useMealUpgradeOption: http.data.useMealUpgradeOption,
                mealUpgradeOption: http.data.mealUpgradeOption,
                autoOrderTea: http.data.autoOrderTea,
                autoOrderTeaFollowPrevMeal: http.data.autoOrderTeaFollowPrevMeal,
                autoOrderMealClass: http.data.autoOrderMealClass,
                autoOrderForPlanned: http.data.autoOrderForPlanned,
                autoOrderMail: http.data.autoOrderMail,
                pbtBehaviorOption: http.data.pbtBehaviorOption,
                navbarBackgroundColor: http.data.navbarBackgroundColor ?? "#b32b23",
                navbarForegroundColor: http.data.navbarForegroundColor ?? "#ffffff",
                pbtShowGuestMealOrderOption: http.data.pbtShowGuestMealOrderOption,
                showQrCodeinMealSlip: http.data.showQrCodeinMealSlip ?? false,
                enableDns153: http.data.enableDns153 ?? false
            };
        }
        return response;
    }

}
